/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleLabels/view.blocks to change it.
import Body from 'DesignSystem/Body/index'
import React from 'react'
import ToggleChildren from 'DesignSystem/ToggleChildren/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ToggleLabels({
  children,
  viewPath = "/DesignSystem/ToggleLabels",
  marginLeft = 0,
  onClickNo,
  isSelectedNo,
  isDisabled,
  paddingTop = 6,
  paddingBottom = 6,
  textNo = "Am",
  isSelected,
  onClickYes,
  isSelectedYes,
  textYes = "Pm"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ToggleLabels.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-1g1V0g': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Horizontal}`}
>
<ToggleChildren
  viewPath={`${viewPath}/ToggleChildren`}
 onClick={onClickNo}
 borderBottomRightRadius={0}
 borderTopRightRadius={0}
 backgroundColor="rgba(111,111,111, 0.05)"
 backgroundColorSelected="rgba(0,188,112, 0.3)"
 backgroundColorSelectedHovered="rgba(0,188,112, 0.8)"
 isSelected={isSelectedNo}
 isDisabled={isDisabled}
 paddingTop={paddingTop}
 paddingBottom={paddingBottom}
>
{childProps => (
<Body
{...childProps}
  viewPath={`${viewPath}/Body`}
 fontSize={12}
 text={textNo}
 color={childProps.isSelectedHovered ? "white" : childProps.isSelected ? "rgb(0,150,89)" : "#323232"}
/>
)}
</ToggleChildren>
<ToggleChildren
  viewPath={`${viewPath}/ToggleChildren`}
 onClick={onClickYes}
 borderBottomLeftRadius={0}
 borderTopLeftRadius={0}
 backgroundColor="rgba(111,111,111, 0.05)"
 backgroundColorSelected="rgba(0,188,112, 0.3)"
 backgroundColorSelectedHovered="rgba(0,188,112, 0.8)"
 isSelected={isSelectedYes}
 isDisabled={isDisabled}
 paddingTop={paddingTop}
 paddingBottom={paddingBottom}
>
{childProps => (
<Body
{...childProps}
  viewPath={`${viewPath}/Body`}
 fontSize={12}
 text={textYes}
 color={childProps.isSelectedHovered ? "white" : childProps.isSelected ? "rgb(0,150,89)" : "#323232"}
/>
)}
</ToggleChildren>
</div>
{children}
</React.Fragment>)
}